import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Address } from "components/Address/Address";
import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Headerbar } from "components/Headerbar/Headerbar";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Person } from "components/Person/Person";
import { Position } from "components/Position/Position";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { useContext, useEffect, useRef, useState } from "react";
import { ContactType, CustomerDictionaryShowMethod, MessageType, OrganizationType } from "types/enum";
import { GUID_EMPTY, ICON_TYPE, INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { convertAddress, convertToISO, disabledFieldCheckValidity, GetReportWithJsonData, GroupingPriceFunction, RoundOutputOperation, RoundWithRoundingPlace, trans, uuidv4 } from "utils/helpers";
import { CustomerTabform } from "../BaseDefinitionAndSetting/Customers/CustomerTabForm";
import { CurrencyDictionary } from "../PriceList/components/CurrencyDictionary/CurrencyDictionary";
import { PriceListDictionary } from "../PriceList/components/PriceListDictionary/PriceListDictionary";
import { SalesInvoiceDetailForm } from "./SalesInvoiceDetailForm";
import {
  CalculateSalesInvoice,
  getDataForPrint,
  getDefaultPersonContact,
  getInvoiceConstraint,
  getPersonCustomer,
  getSalesInvoiceById,
  getSalesInvoiceByReferenceId,
  getSalesInvoiceOrGenerate,
  optionalDiscountHandler,
  postSalesInvoice,
  postSalesInvoiceMiddle,
  postSalesInvoiceWorkFlow,
  putSalesInvoice,
  putSalesInvoiceworkflow,
} from "./api";
import { AddressBox } from "./components/AddressBox/AddressBox";
import { CustomerDictionary } from "./components/CustomerDictionary/CustomerDictionary";
import { CustomerPhoneDictionary } from "./components/CustomerPhoneDictionary/CustomerPhoneDictionary";
import { CustomerPhoneList } from "./components/CustomerPhones/CustomerPhoneList";
import { DocsClassification } from "./components/DocsClassification/DocsClassification";
import { getSalesInvoiceNo } from "./components/SalesInvoiceNo/api";
import { SalesInvoiceSourceId } from "./components/SalesInvoiceSourceId";
import { ButtonPrintIcon } from "components/ButtonPrintIcon/ButtonPrintIcon";
import { SalesCustomerInfo } from "../components/SalesCustomerInfo/SalesCustomerInfo";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { PriceInput } from "components/PriceInput/PriceInput";



interface SalesInvoiceFormProps {
  onHide?: (usenavigate?) => void;
  handleCancelForm?: () => void;
  relod: () => void;
  jobId?: any;
  JobNo?: any;
  processId?: any;
  referenceId?: any;
  taskId?: any;
  mode: any;
  step?: any;
  rowObject?: any;
  SourceData?: any;
  sourceDataParam?: any;
  useGenerate?: any;
  DependentSource?:any
  sourceId?: any;
  buttonPrintObjCallBack?:(any)=>void
}

export const SalesInvoiceForm = ({
  mode,
  relod,
  onHide,
  handleCancelForm,
  rowObject,
  step,
  referenceId,
  taskId,
  jobId,
  JobNo,
  processId,
  sourceDataParam,
  SourceData,
  useGenerate=true,
  sourceId,
  DependentSource,
  buttonPrintObjCallBack
}: SalesInvoiceFormProps) => {
  const [resetForm, setResetForm] = useState(false);
  const [haveSource, setHaveSource] = useState(null);
  const [response, setResponse] = useState<any>();
  const [loading, setLoading] = useState<any>(false);
  const [userChanges, setUserChanges] = useState({});
  const [listPosition, setListPosition] = useState<any>({});
  const [customerInfo, setCustomerInfo] = useState<any>(null);
  const [customer, setCustomer] = useState<any>(null);
  const [salesInvoiceDate, setSalesInvoiceDate] = useState<any>();
  const [cottageDate, setCottageDate] = useState<any>();
  const [selectedObj, setSelectedObj] = useState<any>(null);
  const [showForm, setShowForm] = useState(false);
  const [showAddressBox, setShowAddressBox] = useState<
    "createMode" | "selectMode" | null
  >(null);
  const [showCustomerPhoneForm, setShowCustomerPhoneForm] = useState(false);
  const [showCustomerform, setShowCustomerform] = useState<boolean>(false);
  const [priceList, setPriceList] = useState<any>(null);
  const [salesInvoiceDetail, setSalesInvoiceDetail] = useState<any>([]);
  const [dataGridLoading, setDataGridLoading] = useState<any>(true);
  const [lastWarehouse, setLastWarehouse] = useState<any>(null);
  const [invoiceConstraint, setInvoiceConstraint] = useState<any>({});
  const [responseList, setResponseList] = useState<any>(null);
  const layoutContext = useContext<any>(LayoutContext);

  const [docsClassification, setDocsClassification] = useState<any>(null);
  const [totalRows, setTotalRows] = useState<any>({
    ItemCount: 0,
    TotalTax: 0,
    TotalDiscount: 0,
    SubTotalPrice: 0,
  });
  const [payment, setPayment] = useState<any>({
    TotalPrice: 0,
    Addition: 0,
    Deduction: 0,
    Prepayment: 0,
  });
  const [receive, setReceive] = useState<any>({
    GrandTotalPrice: 0,
    Prepayment: 0,
    DebitPayment: 0,
    NonDebitPayment: 0,
  });
  const [todayDate, settodayDate] = useState<string | null>(
    new Date().toISOString()
  );
  const [optionalDiscount, setOptionalDiscount] = useState<any>(null);
  const [dataChange, setDataChange] = useState<any>(false);
  const [detailMode, setDetailMode] = useState<"create" | "edit" | "view">(mode);
  const [increased, setIncreased] = useState<any>(false);
  const [currencyInfo, setCurrencyInfo] = useState<any>();
  const [changeAddress, setChangeAddress] = useState<any>();
  const [typePhoneContact, setTypePhonContact] = useState<any>();
  const [SendSMS, setSendSMS] = useState(false);
  const [nextInvoiceNumber,setNextInvoiceNumber]=useState<any>()
  const [savedStock,setSavedStock]=useState<any>()
  
  const [person, setPerson] = useState<any>(null);
  const [noAccess, setNoAccess] = useState<any>(false);
  const [dateLoading,setDateLoading]=useState(true)//for calc fun is runing
  const [initialResponse,setInitialResponse]=useState<any>()
  const [selectedPhoneDetail, setSelectedPhoneDetail] = useState<any>({
    phone:'',
    mobilePhone:''
      });
      const[showCustomerInfo,setShowCustomerInfo]=useState(false)

  const [requiredFields,setRequiredFields]=useState<any>()
  const invoiceRef = useRef<any>(null);
  const invoiceRef1 = useRef<any>(null);
  const lang = localStorage.getItem("DefaultLanguage");


  

  function setSalesInvoiceDetailHandler(data) {
    setDataGridLoading(false);
    setSalesInvoiceDetail(data);
    setDataGridLoading(true);
  }
  const handleSalesInvoiceDetailFormSubmit = async (event) => {
    event.preventDefault();
      if( requiredFields?.CustomerAddress){
      const disabledFiedCheckValidityVal=   disabledFieldCheckValidity(event.target.Address) 
       if(disabledFiedCheckValidityVal) return
      }
          const newSavedStock={}as any

    let SubTotalPrice: any = 0;
    let newsalesInvoiceDetail = JSON.parse(JSON.stringify(salesInvoiceDetail)).map((e: any) => {
           newSavedStock[e?.Id]=e?.Qty1

      SubTotalPrice = +e.TotalPrice + SubTotalPrice;
        if (response?.Id == GUID_EMPTY) {
        delete e.Id;
      } 
      return {...e,ExpireDate:e?.ExpireDate?convertToISO(e?.ExpireDate):null};
    });

    let data: any = {
      RecipientPersonDescription:person?.Name??null,
      RecipientPersonId: person?.Id??null,
      CurrencyId: event.target?.CurrencyId?.value,
      SalesInvoiceNo: event.target?.salesInvoiceNo?.value?event.target?.salesInvoiceNo?.value:nextInvoiceNumber ,
      SalesInvoiceDate: salesInvoiceDate,
      DocsClassificationId: (event.target?.docsClassificationId&&event.target?.docsClassificationId?.value!==GUID_EMPTY)?event.target?.docsClassificationId.value:null,
      PriceListId: event.target.PriceList?.value,
      PaymentMethodId: event.target.PaymentMethodId?.value,
      CustomerId: customerInfo.Id,
      CustomerName: customer.Name,
      CustomerPhone:customer.SundryCustomer?event.target?.CustomerPhone?.value: customer?.CustomerPhone?.Name.split(":")[1]?customer?.CustomerPhone?.Name.split(":")[1] :customer?.CustomerPhone?.Name??null,
      CustomerMobilePhone:customer.SundryCustomer?event.target?.CustomerMobilePhone?.value: customer?.CustomerMobilePhone?.Name.split(":")[1]?customer?.CustomerMobilePhone?.Name.split(":")[1] :customer?.CustomerMobilePhone?.Name??null,
      CustomerAddress: event.target.Address?.value??null,
      CustomerEconNo: event.target.CustomerEconNo?.value,
      CustomerNationalCode: event.target.CustomerNationalCode?.value,
      SalesManagerPositionId: listPosition?.SalesManagerPosition?.Id,
      SalesManagerPositionDescription: listPosition?.SalesManagerPosition?.Name,
      SalesManagerPositionDescriptionEN:
      event.target.SalesManagerPositionDescriptionEN?.value,
      VisitorPositionId: listPosition?.VisitorPosition?.Id,
      VisitorPositionDescription: listPosition?.VisitorPosition?.Name,
      VisitorPositionDescriptionEN:
      event.target.VisitorPositionDescriptionEN?.value,
      DistributorPositionId: listPosition?.DistributorPosition?.Id,
      DistributorPositionDescription: listPosition?.DistributorPosition?.Name,
      DistributorPositionDescriptionEN:
      event.target.DistributorPositionDescriptionEN?.value,
      CottageDate: cottageDate,
      DeliveryAddress: event.target.DeliveryAddress?.value,
      CottageNo: event.target.CottageNo?.value,
      PaymentRemark: event.target.PaymentRemark?.value,
      IsCurrancyInvoice: event.target.IsCurrancyInvoice?.checked,
     // CurrencyPrepayment: +event.target.CurrencyPrepayment?.value,
      Description: event.target.Description?.value,
      SourceId: response?.SourceId,
      SourceData: haveSource?haveSource:response?.SourceData,
      IsCurrency: !currencyInfo?.IsDefault,
      CurrencyRate: currencyInfo?.CurrencyRate,
      Addition: +event.target.Addition?.value.replaceAll(",", ""),
      Deduction: +event.target.Deduction?.value.replaceAll(",", ""),
      TotalDiscount: +totalRows?.TotalDiscount,
      TotalPrice: +payment.TotalPrice,
      TotalTax: (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax)) ?    +totalRows?.TotalTax: 0,
      GrandTotalPrice:
        +payment.TotalPrice +
        +totalRows?.TotalTax +
        +event.target.Addition?.value.replaceAll(",", "") -
        +event.target.Deduction?.value.replaceAll(",", ""),
      DebitPayment: +event.target.DebitPayment?.value.replaceAll(",", ""),
      NonDebitPayment: +event.target.NonDebitPayment?.value.replaceAll(",", ""),
      CreditPayment: +event.target.CreditPayment?.value.replaceAll(",", ""),
      Prepayment: +event.target.Prepayment?.value.replaceAll(",", ""),
      SubTotalPrice: +totalRows?.SubTotalPrice,
      SalesInvoiceDetailDTOList: newsalesInvoiceDetail,
    };





let url='FromSource' as any
if(initialResponse?.SalesInvoiceDetailDTOList?.length != salesInvoiceDetail?.length){
  url='FromSourceWithItemEdit'
}else{
salesInvoiceDetail.map(item => {

  let flag = false;

  const foundWithQtyDiff = initialResponse?.SalesInvoiceDetailDTOList.some(res => {
    if (item?.ItemCode == res?.ItemCode) {
      flag = true;
      if (item?.Qty1 != res?.Qty1) {
        url = 'FromSourceWithQtyEdit';
      }
      return true;  // متوقف کردن حلقه some
    }
    return false;
  });

  if (!flag) {
    url = 'FromSourceWithItemEdit';
  }
});


}




    try {
      if (mode == "create") {
        const res = await postSalesInvoice(data, SendSMS,!haveSource?null:url);
        if (res.MessageType == MessageType.success) {
          onHide && onHide(true);
          relod();
        }
      } else {
        if (jobId) {
          if (response.Id == GUID_EMPTY) {
            if(!DependentSource){ 
              const res = await postSalesInvoiceMiddle(
                {
                  ...data,
                  JobId: jobId,
                  JobNo: response?.JobNo ? response?.JobNo : JobNo,
                  TAS_UID: taskId,
                  Id: response.Id,
                },
                referenceId,
                increased,
                SendSMS,
                DependentSource,
                !response?.SourceId?null:'workflow'+url
              );
            }else{

              const res = await postSalesInvoiceWorkFlow(
                {
                  ...data,
                  JobId: jobId,
                  JobNo: response?.JobNo ? response?.JobNo : JobNo,
                  TAS_UID: taskId,
                  Id: response.Id,
                },
                referenceId,
                increased,
                SendSMS,
                'workflow'+url
              );
            }
            getInvoiceAsync();
          } else {
            const res = await putSalesInvoiceworkflow(
              {
                ...data,
                JobId: jobId,
                JobNo: response?.JobNo ? response?.JobNo : JobNo,
                TAS_UID: taskId,
                Id: response?.Id,
              },
              referenceId
            );
          }
        } else {
          const res = await putSalesInvoice({
            ...data,
            JobId: response?.JobId,
            JobNo: response?.JobNo ? response?.JobNo : JobNo,
            TAS_UID: taskId,
            Id: response?.Id,
          });
        }
        //  await   putSalesInvoiceDetail(data)
      }
            setSavedStock(newSavedStock)

    } catch (error:any) {


      if(error.response.data.MessageType==MessageType.confirm){ 

      
        setDateLoading(false);
        Toast(error.response.data.Message, MessageType.confirm,
          () => {


   let result=[] as any

error.response.data.Data?.SalesInvoiceDetailDTOList.map(item=>{
  let flag=false
              salesInvoiceDetail.map(prevItem=>{
                if(prevItem.Id==item.Id){
                  result.push({...item,ExpireDate:prevItem.ExpireDate})
                  flag=true
                }
              })
              if(!flag){
                  result.push(item)

              }
            })	



            setResponse({...error.response.data.Data,SalesInvoiceDate:salesInvoiceDate,
              SalesInvoiceDetailDTOList:result
            });
            setSalesInvoiceDetail(result);
            let newItemCount = 0;
            error.response.data.Data?.SalesInvoiceDetailDTOList.map((item) => {
              newItemCount += item.Qty1;
            });
            setTotalRows({
              ItemCount: newItemCount,
              TotalTax:error.response.data.Data.TotalTax ,
              TotalDiscount: error.response.data.Data?.TotalDiscount,
              SubTotalPrice: error.response.data.Data?.SubTotalPrice,
            });
            setPayment({
              TotalPrice: error.response.data.Data?.TotalPrice,
              Addition: error.response.data.Data?.Addition,
              Deduction: error.response.data.Data?.Deduction,
              Prepayment: error.response.data.Data?.Prepayment,
            });
            setReceive({
              GrandTotalPrice: error.response.data.Data?.GrandTotalPrice,
              Prepayment: error.response.data.Data?.Prepayment,
              DebitPayment: error.response.data.Data?.DebitPayment,
              NonDebitPayment: error.response.data.Data?.NonDebitPayment,
            });
            setResponseList(null)
            setDateLoading(true)

          },
        );
      }


    }
    document.body.classList.remove("loading-indicator-" + lang);
  };





  const sendDataForCalcAsync = async (newPriceList ,Classification=null) => {
  //  setResponseList(null)
    let SubTotalPrice: any = 0;
    let newsalesInvoiceDetail = JSON.parse(
      JSON.stringify(salesInvoiceDetail)
    ).map((e: any) => {
      SubTotalPrice = +e.TotalPrice + SubTotalPrice;
      
      return e;
    });

    let data: any = {
      RecipientPersonDescription: person?.Name??null,
      RecipientPersonId: person?.Id??null,
      CurrencyId: newPriceList?.CurrencyId,
      SalesInvoiceNo: invoiceRef.current?.salesInvoiceNo?.value ?invoiceRef.current?.salesInvoiceNo?.value:nextInvoiceNumber,
      SalesInvoiceDate: salesInvoiceDate,
      DocsClassificationId:invoiceRef.current?.docsClassificationId?.value!==GUID_EMPTY?invoiceRef.current?.docsClassificationId?.value:null,
      PriceListId: newPriceList ?newPriceList.Id  :invoiceRef.current?.PriceList?.value,
      PaymentMethodId: invoiceRef.current?.PaymentMethodId?.value,
      CustomerId: customerInfo?.Id,
      CustomerName: customer?.Name,
      CustomerPhone:customer.SundryCustomer?invoiceRef.current?.CustomerPhone?.value: customer?.CustomerPhone?.Name.split(":")[1]?customer?.CustomerPhone?.Name.split(":")[1] :customer?.CustomerPhone?.Name??null,
      CustomerMobilePhone:customer.SundryCustomer?invoiceRef.current?.CustomerMobilePhone?.value: customer?.CustomerMobilePhone?.Name.split(":")[1]?customer?.CustomerMobilePhone?.Name.split(":")[1] :customer?.CustomerMobilePhone?.Name??null,
      CustomerAddress: invoiceRef.current.Address?.value??null,
      CustomerEconNo: invoiceRef.current?.CustomerEconNo?.value,
      CustomerNationalCode: invoiceRef.current?.CustomerNationalCode?.value,
      SalesManagerPositionId: listPosition?.SalesManagerPosition?.Id,
      SalesManagerPositionDescription: listPosition?.SalesManagerPosition?.Name,
      SalesManagerPositionDescriptionEN:
        invoiceRef.current?.SalesManagerPositionDescriptionEN?.value,
      VisitorPositionId: listPosition?.VisitorPosition?.Id,
      VisitorPositionDescription: listPosition?.VisitorPosition?.Name,
      VisitorPositionDescriptionEN:
        invoiceRef.current?.VisitorPositionDescriptionEN?.value,
      DistributorPositionId: listPosition?.DistributorPosition?.Id,
      DistributorPositionDescription: listPosition?.DistributorPosition?.Name,
      DistributorPositionDescriptionEN:
        invoiceRef.current?.DistributorPositionDescriptionEN?.value,
      CottageDate: cottageDate,
      DeliveryAddress: invoiceRef.current?.DeliveryAddress?.value,
      CottageNo: invoiceRef.current?.CottageNo?.value,
      PaymentRemark: invoiceRef.current?.PaymentRemark?.value,
      IsCurrancyInvoice: invoiceRef.current?.IsCurrancyInvoice?.checked,
      //CurrencyPrepayment: +invoiceRef.current?.CurrencyPrepayment?.value,
      Description: invoiceRef.current?.Description?.value,
      SourceId: response?.SourceId,
      SourceData: haveSource?haveSource:response?.SourceData,
      IsCurrency: !currencyInfo?.IsDefault,
      CurrencyRate: currencyInfo?.CurrencyRate,
      Addition: +invoiceRef.current?.Addition?.value.replaceAll(",", ""),
      Deduction: +invoiceRef.current?.Deduction?.value.replaceAll(",", ""),
      TotalDiscount: +totalRows?.TotalDiscount,
      TotalPrice: +payment.TotalPrice,
      TotalTax: (docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax)) ?    +totalRows?.TotalTax: 0,
      GrandTotalPrice:
      +payment.TotalPrice +
        +totalRows?.TotalTax +
        +invoiceRef.current.Addition?.value.replaceAll(",", "") -
        +invoiceRef.current.Deduction?.value.replaceAll(",", ""),
      DebitPayment: +invoiceRef.current?.DebitPayment?.value.replaceAll(",", ""),
      NonDebitPayment: +invoiceRef.current?.NonDebitPayment?.value.replaceAll(",", ""),
      CreditPayment: +invoiceRef.current?.CreditPayment?.value.replaceAll(",", ""),
      Prepayment: +invoiceRef.current?.Prepayment?.value.replaceAll(",", ""),
      SubTotalPrice: +totalRows?.SubTotalPrice,
      SalesInvoiceDetailDTOList: newsalesInvoiceDetail,
      JobId: jobId,
      JobNo: response?.JobNo ? response?.JobNo : JobNo,
      TAS_UID: taskId,
      Id: response.Id,
    };
    setDateLoading(false)

    
    try {
      
      if ((mode !== "view"&& priceList.Id != newPriceList?.Id)||newPriceList==null) {
        const res = await CalculateSalesInvoice(data);
        setResponse(res.Data);
        

        setSalesInvoiceDetail(res.Data?.SalesInvoiceDetailDTOList	);
        let newItemCount = 0;
        res.Data?.SalesInvoiceDetailDTOList.map((item) => {
          newItemCount += item.Qty1;
        });
        setTotalRows({
          ItemCount: newItemCount,
          TotalTax:res.Data.TotalTax ,
          TotalDiscount: res.Data?.TotalDiscount,
          SubTotalPrice: res.Data?.SubTotalPrice,
        });
        setPayment({
          TotalPrice: res.Data?.TotalPrice,
          Addition: res.Data?.Addition,
          Deduction: res.Data?.Deduction,
          Prepayment: res.Data?.Prepayment,
        });
        setReceive({
          GrandTotalPrice: res.Data?.GrandTotalPrice,
          Prepayment: res.Data?.Prepayment,
          DebitPayment: res.Data?.DebitPayment,
          NonDebitPayment: res.Data?.NonDebitPayment,
        });
        setResponseList(null)

      }
      setPriceList(newPriceList);
    } catch (error:any) {
      if(error.response?.data?.Data[0]&&error.response?.data?.Data?.[0]?.Message){
        let obj = {}
        error.response.data.Data.map(item=>{
          obj[item.Data] = item
        })
        setResponseList(obj)
      }
      setPriceList(priceList);
    } 
    if(Classification) setDocsClassification(Classification)
      setDateLoading(true)

  };


  

  async function getDefaultPersonContactAsync(personId) {

    
    if (personId != customerInfo?.Id || customerInfo == null)
      try {

        const res2 = await getPersonCustomer(personId);

        setCustomer((pre) => {
          return {
            ...pre,
            Id: res2.Data.Customer.Id,
            Name: res2.Data.Customer.CustomerPersonDescription,
            SundryCustomer: res2.Data.Customer.Id == invoiceConstraint?.SundryCustomerId,
          };
        });
        if (res2.Data.Customer.Id == invoiceConstraint?.SundryCustomerId	) {
          setCustomerInfo({  ...res2?.Data?.Customer });
        } else {
          if(mode!="view"){
            const res = await getDefaultPersonContact(
              res2?.Data?.Customer?.CustomerPositionId
            );
            setCustomerInfo({ ...res.Data, ...res2?.Data?.Customer });

          }else setCustomerInfo({  ...res2?.Data?.Customer });

        }



        setListPosition({
          DistributorPosition: {
            Id: res2?.Data?.Customer.DistributorPositionId,
            Name: res2?.Data?.Customer.DistributorPositionDescription,
          },
          VisitorPosition: {
            Id: res2?.Data?.Customer.VisitorPositionId,
            Name: res2?.Data?.Customer.VisitorPositionDescription,
          },
        });
      } catch (error) {}
  }
  async function getInvoiceConstraintAsync(withLoading = false) {
    if (withLoading) setLoading(false);
    try {
      const res = await getInvoiceConstraint();
      setInvoiceConstraint(res.Data);
      setNextInvoiceNumber(res.Data?.DocNo)
      setRequiredFields(res.Data.RequiredFields?JSON.parse(res.Data.RequiredFields):null)
    if (withLoading) setLoading(true);
      return res.Data
    } catch (error) {}
    if (withLoading) setLoading(true);
  }

  async function getInvoiceAsync() {
    setLoading(false);
  //  const constraint= await getInvoiceConstraintAsync();
  let constraint ={} as any
  if(mode!='view') {constraint= await getInvoiceConstraintAsync()}
    try {
      if (jobId) {
        let res:any
        if(useGenerate && (sourceDataParam && mode!='view') ){
             res = await getSalesInvoiceOrGenerate(
            sourceDataParam ,
            sourceId,
            referenceId,
            jobId,
            DependentSource
          );

        }else{

         //res = await getSalesInvoiceById(jobId);
           res = await getSalesInvoiceByReferenceId(referenceId,DependentSource);
        }
          if(res.Data.Id !=GUID_EMPTY) setNextInvoiceNumber(res.Data.SalesInvoiceNo)
                  if(res.Data.Id && res.Data.Id!=GUID_EMPTY){
                    if(invoiceRef1.current!=null){
                      buttonPrintObjCallBack&& buttonPrintObjCallBack({
                        Id: res.Data.Id ,
                        reportDomain:"OfficeAutomation",
                        objectTag:"SalesInvoiceForm",
                        apiFunction:getDataForPrint
                      })
                    }
                  }else{
                    buttonPrintObjCallBack&& buttonPrintObjCallBack(null) 
                  }
          setResponse(res.Data);
          setInitialResponse(res.Data)
          let count = 0;
          res.Data.SalesInvoiceDetailDTOList.map((item) => {
            count += +item?.Qty1;
          });
          setHaveSource(res.Data.SourceData);
          setSalesInvoiceDetail(res.Data.SalesInvoiceDetailDTOList);
          
          setTotalRows({
            ItemCount: count,
            TotalTax:  res.Data.TotalTax,
            TotalDiscount: res.Data?.TotalDiscount,
            SubTotalPrice: res.Data?.SubTotalPrice,
          });
          setPayment({
            TotalPrice: res.Data?.TotalPrice,
            Addition: res.Data?.Addition,
            Deduction: res.Data?.Deduction,
            Prepayment: res.Data?.Prepayment,
          });

          setReceive({
            GrandTotalPrice: res.Data?.GrandTotalPrice,
            Prepayment: res.Data?.Prepayment,
            DebitPayment: res.Data?.DebitPayment,
            NonDebitPayment: res.Data?.NonDebitPayment,
          });
           let savedStockObj={}
    res.Data?.SalesInvoiceDetailDTOList.map((item)=>savedStockObj[item?.Id]=item?.Qty1)
    setSavedStock(savedStockObj)
          if (mode=='view') setInvoiceConstraint({IsFiscal:res.Data.IsFiscal,})

        
      } else {
        const res = await getSalesInvoiceById(rowObject.Id);
        setNextInvoiceNumber(res.Data.SalesInvoiceNo)
        setHaveSource(res.Data.SourceData);
        if(res.Data.Id && res.Data.Id!=GUID_EMPTY){
          if(invoiceRef1.current!=null){
          buttonPrintObjCallBack&& buttonPrintObjCallBack({
            Id: res.Data.Id ,
            reportDomain:"OfficeAutomation",
            objectTag:"SalesInvoiceForm",
            apiFunction:getDataForPrint
          })}   
        }else{
          buttonPrintObjCallBack&& buttonPrintObjCallBack(null) 
        }
        setResponse(res.Data);
        setInitialResponse(res.Data)
        let count = 0;
        res.Data.SalesInvoiceDetailDTOList.map((item) => {
          count += +item?.Qty1;
        });
        setSalesInvoiceDetail(res.Data.SalesInvoiceDetailDTOList);
        setTotalRows({
          ItemCount: count,
          TotalTax:res.Data.TotalTax,
          TotalDiscount: res.Data?.TotalDiscount,
          SubTotalPrice: res.Data?.SubTotalPrice,
        });
        setPayment({
          TotalPrice: res.Data?.TotalPrice,
          Addition: res.Data?.Addition,
          Deduction: res.Data?.Deduction,
          Prepayment: res.Data?.Prepayment,
        });
        setReceive({
          GrandTotalPrice: res.Data?.GrandTotalPrice,
          Prepayment: res.Data?.Prepayment,
          DebitPayment: res.Data?.DebitPayment,
          NonDebitPayment: res.Data?.NonDebitPayment,
        });
         let savedStockObj={}
    res.Data?.SalesInvoiceDetailDTOList.map((item)=>savedStockObj[item?.Id]=item?.Qty1)
    setSavedStock(savedStockObj)
        if (mode=='view') setInvoiceConstraint({IsFiscal:res.Data.IsFiscal,ItemNoPriceText:localStorage.getItem("ECommerce_NoPriceText")})

      }
    } catch (error) {}
    setLoading(true);
  }

  async function optionalDiscountHandlerAsync() {
    let data = {
      CurrencyRoundingPlace: currencyInfo?.CurrencyRoundingPlace,
      OptionalDiscount: +optionalDiscount,
      Addition: +payment.Addition,
      Deduction: +payment.Deduction,
      DetailDTOList: salesInvoiceDetail,
    };
    try {
      const res = await optionalDiscountHandler(data);
      setTotalRows({
        ItemCount: res.Data.ItemCount,
        TotalTax: res.Data.TotalTax,
        TotalDiscount: res.Data.TotalDiscount,
        SubTotalPrice: res.Data.SubTotalPrice,
      });
      setPayment((e)=>{return  {
           ...e,
        TotalPrice:res.Data.TotalPrice,
      }} );
      
      setSalesInvoiceDetailHandler(res.Data.SalesInvoiceDetailDTOList);
    } catch (error) {}
  }




  const handleOpenDetailForm=()=>{
      if (priceList) {
        if(customerInfo?.CustomerPersonId|| customer?.SundryCustomer){
          setShowForm(true);
          setDetailMode("create");
        }else{
        // Toast("please select customer", "error");
        Toast("msg_customernotselected", MessageType.error);

        }
      } else {
        // Toast("msg_choosepricelist", "error");
        Toast("msg_choosepricelist",MessageType.error);

      }
    
}

  const handlesetPriceListDetail = (newObj) => {
  if(detailMode == "create" || (detailMode == "edit" && newObj.ItemCode!=selectedObj.ItemCode)){
     setIncreased(true)
    }
    if (invoiceConstraint.AllowDuplicateItems || detailMode == "edit") {
       if(detailMode=="create"){
          const findItem=initialResponse?.SalesInvoiceDetailDTOList?.find(item1=>item1.ItemId==newObj.ItemId)
            if(findItem){
            setSavedStock({...savedStock,[newObj.Id]:findItem.Qty1})

          }else{
             setSavedStock({...savedStock,[newObj?.Id]:0})
            }
      }
      setTotalRows({
        ItemCount:
          detailMode == "create"
            ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty1)
            : RoundOutputOperation(totalRows.ItemCount + (+newObj.Qty1 - +selectedObj.Qty1)),
        TotalTax:
          detailMode == "create"
            ? totalRows.TotalTax + +newObj.Tax
            : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax),
            TotalDiscount:
            detailMode == "create"
              ?( totalRows.TotalDiscount + +newObj.Discount + (newObj.CustomerDiscount?+newObj.CustomerDiscount:0))
              : totalRows.TotalDiscount +
                (+newObj.Discount - +selectedObj.Discount) + (+newObj.CustomerDiscount?+newObj.CustomerDiscount - +selectedObj.CustomerDiscount :0),
        SubTotalPrice:
          detailMode == "create"
            ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
            : totalRows.SubTotalPrice +
              (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
      });

        setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );
      if (detailMode == "create") {
        setSalesInvoiceDetailHandler([...salesInvoiceDetail, newObj]);
      } else {
        let newItemes = salesInvoiceDetail?.map((item: any) => {
          if (item.Id == newObj.Id) {
            return newObj;
          }
             else if((newObj.Id.replace("changeId","")==item.Id )){

           const newData={...newObj , Id: uuidv4()}
            const findItem=initialResponse?.SalesInvoiceDetailDTOList?.find(item1=>item1.ItemId==newObj.ItemId)
            if(findItem){
            setSavedStock({...savedStock,[newData.Id]:findItem.Qty1})

          }else{
              setSavedStock({...savedStock,[newData.Id]:0})
            }
            return newData;
                        
                      }
          else return item;
        });

        
        setSalesInvoiceDetailHandler(newItemes);
      }
      setDataChange(true);
      return true
    } else {
     if(detailMode=="create"){
           const findItem=initialResponse?.SalesInvoiceDetailDTOList?.find(item1=>item1.ItemId==newObj.ItemId)
            if(findItem){
            setSavedStock({...savedStock,[newObj.Id]:findItem.Qty1})

          }else{
             setSavedStock({...savedStock,[newObj?.Id]:0})
            }
      }
      let Dupli = salesInvoiceDetail?.find(
        (e: any) => e.ItemId == newObj.ItemId
      );
      if (!Dupli || salesInvoiceDetail.length == 0) {
        setTotalRows({
          ItemCount:
            detailMode == "create"
              ? RoundOutputOperation(totalRows.ItemCount + newObj.Qty1)
              : RoundOutputOperation(totalRows.ItemCount + (+newObj.Qty1 - +selectedObj.Qty1)),
          TotalTax:
            detailMode == "create"
              ? totalRows.TotalTax + +newObj.Tax
              : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax),
              TotalDiscount:
              detailMode == "create"
                ? totalRows.TotalDiscount + +newObj.Discount + (newObj.CustomerDiscount?+newObj.CustomerDiscount:0)
                : totalRows.TotalDiscount +
                  (+newObj.Discount - +selectedObj.Discount)+ (+newObj.CustomerDiscount?+newObj.CustomerDiscount - +selectedObj.CustomerDiscount :0),
          SubTotalPrice:
            detailMode == "create"
              ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
              : totalRows.SubTotalPrice +
                (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
        });
        setPayment((e)=>{return  {
           ...e,
        TotalPrice:detailMode == "create"
            ? payment.TotalPrice + +newObj.TotalPrice 
            : payment.TotalPrice +
              (+newObj.TotalPrice - +selectedObj.TotalPrice),
      }} );
        if (detailMode == "create") {
          setSalesInvoiceDetailHandler([...salesInvoiceDetail, newObj]);
        } else {
          let newItemes = salesInvoiceDetail?.map((item: any) => {
            if (item.Id == newObj.Id) {
              return newObj;
            } 
              else if((newObj.Id.replace("changeId","")==item.Id )){

          const newData={...newObj , Id: uuidv4()}
            const findItem=initialResponse?.SalesInvoiceDetailDTOList?.find(item1=>item1.ItemId==newObj.ItemId)
            if(findItem){
            setSavedStock({...savedStock,[newData.Id]:findItem.Qty1})

          }else{
              setSavedStock({...savedStock,[newData.Id]:0})
            }
            return newData;
                        
                      }
            else return item;
          });
          setSalesInvoiceDetailHandler(newItemes);
        }
        setDataChange(true);
        // Toast("msg_saveddatasuccessfully", "success");
        Toast("msg_saveddatasuccessfully", MessageType.success);

        return true
      } else {
        // Toast("msg_duplicateitems", "error");
        Toast("msg_duplicateitems", MessageType.error);

        return false
      }
    }
  };
  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };

  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide && onHide();
      // });
      Toast(trans("modalclosemessage"),MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide && onHide();
      });
    } else {
      onHide && onHide();
    }
  }

  const getDataForPrintAsync =async (id) => {
    if(response?.Id){
        if(id.includes("Design")){
            const res = await getDataForPrint(response?.Id)
            GetReportWithJsonData( id.replace("Design" , ""), res.Data ,2)
        }else if(id.includes("Default")){
            const res = await getDataForPrint(response?.Id)
            GetReportWithJsonData( id.replace("Default" , ""), res.Data ,2)
        }else{
            const res = await getDataForPrint(response?.Id)
/*               const dataStr = JSON.stringify(res.Data);
            const blob = new Blob([dataStr], { type: 'application/json' });
            const url = URL.createObjectURL(blob); */
           GetReportWithJsonData( id, res.Data ,1 )
        }
    }
    try {
    } catch (error) {
        
    }
};

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  const handleDeleteRow = async (id: string = selectedObj.Id) => {
    let newPriceListDetail: any = [...salesInvoiceDetail];
    let obj = newPriceListDetail.filter((e) => e.Id == id)[0];

    setTotalRows({
      ItemCount: RoundOutputOperation(totalRows.ItemCount - +obj.Qty1),
      TotalTax: totalRows.TotalTax - +obj.Tax,
      TotalDiscount: totalRows.TotalDiscount - +obj.Discount - +obj.CustomerDiscount,
      SubTotalPrice: totalRows.SubTotalPrice - +obj.SubTotalPrice,
    });
     setPayment((e)=>{return  {
           ...e,
        TotalPrice:e.TotalPrice - +obj.TotalPrice, 
      }} );
    setSalesInvoiceDetailHandler(newPriceListDetail.filter((e) => e.Id != id));
  };

  const handleSourceData = (obj, type) => {
    setResponse(obj);
    setInitialResponse(obj)
    setHaveSource(type);
    setPriceList({ ...priceList, Id: obj.PriceListId });
    setSalesInvoiceDetailHandler(obj.SalesInvoiceDetailDTOList);
    setTotalRows({
      ItemCount: obj?.ItemCount,
      TotalTax: obj?.TotalTax,
      TotalDiscount: obj?.TotalDiscount,
      SubTotalPrice: obj?.SubTotalPrice,
    });
   setPayment((e)=>{return  {
           ...e,
        TotalPrice:obj?.TotalPrice,
      }} );
    setCustomer((prev)=>{return{ ...prev,Id: obj?.CustomerId, Name: obj?.CustomerName }});
  };
  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (mode != "create") {
      getInvoiceAsync();
    } else {
      getInvoiceConstraintAsync(true);
    }
  }, []);
  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);
/*   useEffect(() => {
        if(currencyInfo?.PriceRoundingPlace){
    setPayment((prev) => {
      return {
        ...prev,
        TotalPrice:  RoundWithRoundingPlace(
                          +totalRows?.SubTotalPrice - +totalRows?.TotalDiscount,
                          currencyInfo?.PriceRoundingPlace
                        ),
      };
    });
                }else{
    setPayment((prev) => {
      return {
        ...prev,
        TotalPrice: +totalRows?.SubTotalPrice - +totalRows?.TotalDiscount,
      };
    });
    
          }

  }, [totalRows,currencyInfo?.PriceRoundingPlace]); */
  useEffect(() => {
    setReceive((prev) => {
      return {
        ...prev,
        GrandTotalPrice:
          +payment.TotalPrice +
          +payment?.Addition +
          +totalRows?.TotalTax -
          +payment?.Deduction,
      };
    });
  }, [payment]);

  const getSalesInvoiceNoAsync = async ()=>{

    try {
    const res = await getSalesInvoiceNo(docsClassification?.Id!=GUID_EMPTY ?docsClassification?.Id:null)
    setNextInvoiceNumber(res.Data)
    
    } catch (error:any) {

    }

  }

useEffect(() => {
  if((mode!="view") && docsClassification?.Id!=GUID_EMPTY && !invoiceConstraint.IsClassificationIgnored ){
    getSalesInvoiceNoAsync()

  }else if (mode=="view")setNextInvoiceNumber(response?.SalesInvoiceNo)

   
  }, [docsClassification]);




  return (
    <div ref={invoiceRef1} className=" ">
      {showForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowForm(false);
          }}
          modalProfileKey="SalesInvoiceDetailForm"
          show={showForm}
          title={"SalesInvoiceDetailForm"}
        >
          <SalesInvoiceDetailForm
            setLastWarehouse={setLastWarehouse}
            lastWarehouse={lastWarehouse}
            mode={detailMode}
            onHide={() => {
              setShowForm(false);
            }}
            initialStock={response?.Id==GUID_EMPTY?0:savedStock[selectedObj?.Id]}
            docsClassification={docsClassification}
            priceList={priceList}
            invoiceConstraint={invoiceConstraint}
            selectedObj={selectedObj}
            SalesInvoiceDetailCallBack={(e) => handlesetPriceListDetail(e)}
            personId={customerInfo?.CustomerPersonId}
            currency={currencyInfo}
            SalesInvoiceId={response?.Id}
            jobId={jobId}
          />
        </ModalForm>
      ) : (
        <></>
      )}

            
     {showCustomerInfo ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowCustomerInfo(false);
          }}
          show={showCustomerInfo}
          title={"Customer"}
        >
         <SalesCustomerInfo customerId={customer?.Id}/>
        </ModalForm>
      ) : (
        <></>
      )}
      {showCustomerPhoneForm ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowCustomerPhoneForm(false);
          }}
          show={showCustomerPhoneForm}
          title={"CustomerPhoneForm"}
        >
          <CustomerPhoneList
            CustomerPositionId={
              response?.CustomerPositionId
                ? response?.CustomerPositionId
                : customerInfo?.CustomerPositionId
            }
            personId={
              response?.CustomerPersonId
                ? response?.CustomerPersonId
                : customerInfo?.CustomerPersonId
            }
            onHide={() => {
              setShowCustomerPhoneForm(false);
            }}
            type={typePhoneContact}
            handlePhone={(e) => {
              typePhoneContact==ContactType.Phone?setSelectedPhoneDetail({...selectedPhoneDetail, phone:e}):setSelectedPhoneDetail({...selectedPhoneDetail, mobile:e})
            }}
          />
        </ModalForm>
      ) : (
        <></>
      )}

      {showAddressBox ? (
        <ModalForm
          modalHeight={49}
          onHide={() => {
            setShowAddressBox(null);
          }}
          mode={mode}
          show={showAddressBox && true}
          title={"Address"}
        >
          <AddressBox
            personId={
              response?.CustomerPersonId
                ? response?.CustomerPersonId
                : customerInfo?.CustomerPersonId
            }
            CustomerPositionId={
              response?.CustomerPositionId
              ? response.CustomerPositionId
              : customerInfo?.CustomerPositionId
            }
            onHide={() => {
              setShowAddressBox(null);
            }}
            status={showAddressBox}
            AddressHandeler={(e) => {
              setChangeAddress(JSON.stringify(e).toLowerCase());
              setCustomerInfo({
                ...customerInfo,
                Address: JSON.stringify(e).toLowerCase(),
              });
              setShowAddressBox(null);
            }}
          />
        </ModalForm>
      ) : (
        <></>
      )}

      {showCustomerform ? (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowCustomerform(false);
          }}
          show={showCustomerform}
          title={"Customer"}
        >
          <CustomerTabform
            selectedObj={customer}
            mode={mode}
            onHide={() => {
              setShowCustomerform(false);
            }}
          />
        </ModalForm>
      ) : (
        <></>
      )}

      {loading ? (
        <form onSubmit={handleSalesInvoiceDetailFormSubmit} ref={invoiceRef}>
             {/* <div className="col-12 d-flex justify-content-end" style={{position:'absolute',top:'30px',zIndex:'10'}}>
        {  (response?.Id!==GUID_EMPTY && response?.Id) &&  <ButtonPrintIcon reportDomain={"OfficeAutomation"}  objectTag={"SalesInvoiceForm"} Callback={(e) => {getDataForPrintAsync(e)}} />}
            </div> */}
         
          <FormWithTitle
            title={trans("SalesInvoice")}
            defualtClose={true}
            showFristRow={true}
            closeOption={true}
            dynamicTitle={response?.Id!=GUID_EMPTY?{
              CustomerName: customer?.Name,
              salesinvoiceno: nextInvoiceNumber,
              ...(response?.JobNo && { JobNo: response?.JobNo })
            }:''}
          >
            <div className="card-body" style={{paddingTop:'1px'}}>
              <div className="row">
           
                <div className="col-lg-1 col-11">
                  <SalesInvoiceSourceId
                    SourceObjCallBack={(e, type) => {
                      handleSourceData(e, type);
                    }}
                    value={haveSource ? haveSource : "undefined"}
                    resetForm={resetForm}
                    dataChange={dataChange}
                    mode={mode }
                  />
                </div>

                {invoiceConstraint?.IsDocClassified && (
                  <div className="col-lg-2 col-11 me-lg-3 mt-3 mt-lg-0">
                    <DocsClassification
                      label="Classification"
                      name="docsClassificationId"
                      baseUrl={INVENTORYANDSALES_URL}
                      IsDocClassified={invoiceConstraint?.IsDocClassified}
                      endPoint={
                        ENDPOINTSINVENTORYANDSALES.Sales
                          .BaseDefinitionAndSetting.SalesDocsClassification
                          .dictionaryDetail
                      }
                      resetForm={resetForm}
                      value={docsClassification?docsClassification?.Id: (response?.DocsClassificationId?response?.DocsClassificationId: customerInfo?.DefaultSalesInvoiceClassificationId)}
                      mode={ mode}
                      onChange={(e,obj) => {
                        if((docsClassification?.CalculateTax!=obj?.CalculateTax)&&docsClassification!=null){sendDataForCalcAsync(null , obj) }else    setDocsClassification(obj);
                      }}
                    />
                  </div>
                )}
                {/* {(invoiceConstraint.IsDocClassified ||
                  docsClassification) && ( */}
                  <div className="col-lg-1 col-11">
                         <Textbox
                           textboxType="text"
                           textboxName="salesInvoiceNo"
                           labelText="number"
                           defaultValue={nextInvoiceNumber}
                           resetForm={resetForm}
                           readonly={!invoiceConstraint?.IsDocNoEditable || mode!=='create' ?true:false}
                           onChange={(e)=>{setNextInvoiceNumber(e.target.value);}}
                           mode={mode}
                          />
                  </div>
                {/* )} */}
          { dateLoading &&     <div className="col-lg-2 col-11">
                  <Datepicker
                    mode={
                      mode == "view" || invoiceConstraint?.IsNewDocCurrentDate
                        ? "view"
                        : mode
                    }
                    lable="Date"
                    required={true}
                    setIsoTime={(isoTime: string) => {
                      setSalesInvoiceDate(isoTime);
                    }}
                    val={
                      response?.SalesInvoiceDate
                        ? response?.SalesInvoiceDate
                        : invoiceConstraint?.IsNewDocCurrentDate
                        ? todayDate
                        : null
                    } //resetForm ? new Date().toISOString() :
                    errorFlag={false}
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                  />
                </div>}

                <div className={`${(mode=='create'&&!haveSource) && !noAccess?'col-lg-3':'col-lg-3'} col-11 row`}>
                  <div className={`col flex-grow-1  `}>

                   <CustomerDictionary
                               checkHasAccess={()=>setNoAccess(true)}
                                 name="CustomerName"
                                 label="CustomerName"
                                 resetForm={resetForm}
                                 value={haveSource?response?.CustomerId:''}
                                 ShowMethod={invoiceConstraint?.ChangeDocCustomer}
                                 CustomerName={response?.CustomerName	}
                                 mode={(haveSource&&invoiceConstraint?.CustomerDictionaryShowMethod==CustomerDictionaryShowMethod.OnlyCustomer)  ?"view":   mode}
                                 returnObj={true}
                                 required={true}
                                 onChange={(e) => {
                                   if(e.Id){
                                     setCustomer((prev) => {
                                       return { ...e, ...prev };
                                     });
                                     getDefaultPersonContactAsync(e.Id);
                                   }
                                 }}
                                 
                               />
                  </div>
              {(mode=='create'&&!haveSource) && !noAccess && <div
              className="col-auto"
                  style={{
                    marginTop: "25px",
                    // width: "1%",
                     marginRight: "-20px",
                  }}
                >
                  <Button
                    Icon={true}
                    value={
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setShowCustomerform(true);
                          
                        }}
                        className="checkButton d-flex align-items-center justify-content-center"
                      >
                        {" "}
                        <FontAwesomeIcon icon={[ICON_TYPE, "plus"]} size="2x" />
                      </button>
                    }
                    btnType="primary"
                  />
                </div>}
                    {!noAccess && layoutContext?.currentUserPosition?.OrganizationType!=OrganizationType.Customers  && (
                                    <>
                                    <div
                                    className="col-auto"
                                     style={{
                                      marginTop: "25px",
                                     marginRight: "-10px",
                                    }}
                                    >
                                      <Button
                                        Icon={true}
                                        value={
                                          <button
                                          disabled={!customer?.Id}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setShowCustomerInfo(true);
                                            }}
                                            className={`${!customer?.Id?'opacity-50':'opacity-1'} checkButton d-flex align-items-center justify-content-center`}
                                          >
                                            {" "}
                                            <FontAwesomeIcon
                                              icon={[ICON_TYPE, "info"]}
                                     
                                            />
                                          </button>
                                        }
                                        btnType="primary"
                                      />
                                    </div>
                
                                    </>
                                  )}
                </div>


                <div className="col-lg-2 col-11 me-lg-1">
                  <PriceListDictionary
                    name="PriceList"
                    label="PriceList"
                    required={true}
                    resetForm={resetForm}
                    value={
                      invoiceConstraint?.UseCustomerPriceList &&  customerInfo?.PriceListId?customerInfo?.PriceListId:
                      priceList == null ||
                      !priceList ||
                      priceList.Id == GUID_EMPTY 
                        ?response?.PriceListId
                        : priceList.Id
                    }
                    mode={invoiceConstraint?.UseCustomerPriceList && customerInfo?.PriceListId ?'view':mode}
                    onChange={(e) => {
                      if( salesInvoiceDetail.length>0&&e.Id != GUID_EMPTY &&(response?.PriceListId != e.Id || (priceList&&e.Id!= priceList?.Id)) ){
sendDataForCalcAsync(e)
                      }
                      else{
setResponseList(null);setPriceList(e);
                      } 
                    }}
                  />
                </div>
                <div className="col-lg-1 col-11">
                  <CurrencyDictionary
                    onChange={(obj, id) => {
                      setCurrencyInfo(obj);
                    }}
                    name="CurrencyId"
                    label="Currency"
                    resetForm={resetForm}
                    value={
                      priceList?.CurrencyId
                        ? priceList?.CurrencyId
                        : response?.CurrencyId
                    }
                    mode={priceList?.CurrencyId ? "view" : mode}
                    required={true}
                  />
                </div>

                {/* {mode=='create' && <div className="col-lg-2 col-11 d-flex align-items-center mb-1 mb-lg-0">
                           <CheckableButton
                                Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                defaultChecked={SendSMS}
                                defaultValue={SendSMS}
                                readOnly={mode==='view'}
                                checked={SendSMS}
                                onchange={setSendSMS}
                                labelText={"NotifyBySMS"}
                                inputName={"NotifyBySMS"}
                                type="checkbox"
                                mode={mode}
                                />
                            </div>} */}

                <div className="col-lg-2 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxType="text"
                    textboxName="CustomerEconNo"
                    labelText="CustomerEconNo"
                    defaultValue={
                      response?.CustomerEconNo
                        ? response?.CustomerEconNo
                        : customerInfo?.EconNo
                    }
                    resetForm={resetForm}
                    mode={mode}
                    required={requiredFields?.CustomerEconNo}
                  />
                </div>
                {!customer?.SundryCustomer ? (
                <div className="col-lg-2 col-11 d-flex">
                <div className="flex-grow-1">
                <CustomerPhoneDictionary
                  required={requiredFields?.CustomerPhone}
                  type={ContactType.Phone}
                  name="CustomerPhone"
                  label="CustomerPhone"
                  resetForm={resetForm}
                  valueString={
                    response?.CustomerPhone && !selectedPhoneDetail.phone.Value  && mode !== "create"
                      ? response?.CustomerPhone
                      :selectedPhoneDetail.phone.Value?? customerInfo?.PhoneNumber
                  }
                  mode={response?.CustomerPositionId || customerInfo?.CustomerPositionId?mode:'view' }
                  returnObj={true}
                  CustomerPositionId={
                    response?.CustomerPositionId
                      ? response?.CustomerPositionId
                      : customerInfo?.CustomerPositionId
                  }
                  onChange={(e) => {
                    setCustomer((prev)=>{return{ ...prev, CustomerPhone: e }});

                  }}
                />
                </div>
         { mode!=='view' &&    <div
                style={{
                  marginTop: "25px",
                  width: "17px",
                  // marginRight: "-25px",
                }}
                // className="ms-4"
              >
                <Button
                  Icon={true}
                  value={
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowCustomerPhoneForm(true);
                        setTypePhonContact(ContactType.Phone);
                      }}
                      className="checkButton d-flex align-items-center justify-content-center"
                    >
                      {" "}
                      <FontAwesomeIcon icon={[ICON_TYPE, "plus"]} size="2x" />
                    </button>
                  }
                  btnType="primary"
                />
              </div>}
              </div>
                ) : (
                  <div className="col-11 col-lg-2 d-flex">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxType="text"
                      textboxName="CustomerPhone"
                      labelText="CustomerPhone"
                      defaultValue={
                        response?.CustomerPhone ? response?.CustomerPhone : ""
                      }
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.CustomerPhone}
                    />
                  </div>
                )}



{!customer?.SundryCustomer ? (
                <div className="col-lg-2 col-11 d-flex">
                <div className="flex-grow-1">
                <CustomerPhoneDictionary
                  required={requiredFields?.CustomerMobilePhone}
                  type={ContactType.Mobile}
                  name="CustomerMobilePhone"
                  label="CustomerMobilePhone"
                  resetForm={resetForm}
                  valueString={
                    response?.CustomerMobilePhone && !selectedPhoneDetail.mobile?.Value && mode !== "create"
                      ? response?.CustomerMobilePhone
                      :selectedPhoneDetail.mobile?.Value??customerInfo?.MobilePhone
                  }
                  mode={response?.CustomerPositionId  || customerInfo?.CustomerPositionId?mode:'view' }

                  returnObj={true}
                  CustomerPositionId={
                    response?.CustomerPositionId
                      ? response?.CustomerPositionId
                      : customerInfo?.CustomerPositionId
                  }
                  onChange={(e) => {
                    setCustomer((prev)=>{return{ ...prev, CustomerMobilePhone: e }});
                  }}
                />
                </div>
            { mode!=='view' && <div
                style={{
                  marginTop: "25px",
                  width: "17px",
                  // marginRight: "-25px",
                }}
                // className="ms-4"

              >
                <Button
                  Icon={true}
                  value={
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowCustomerPhoneForm(true);
                        setTypePhonContact(ContactType.Mobile);
                      }}
                      className="checkButton d-flex align-items-center justify-content-center"
                    >
                      {" "}
                      <FontAwesomeIcon icon={[ICON_TYPE, "plus"]} size="2x" />
                    </button>
                  }
                  btnType="primary"
                />
              </div>}
              </div>
                ) : (
                  <div className="col-11 col-lg-2 d-flex">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxType="text"
                      textboxName="CustomerMobilePhone"
                      labelText="CustomerMobilePhone"
                      defaultValue={
                        response?.CustomerMobilePhone
                          ? response?.CustomerMobilePhone
                          : ""
                      }
                      resetForm={resetForm}
                      mode={mode}
                      required={requiredFields?.CustomerMobilePhone}
                    />
                  </div>
                )}


                <div className="col-lg-2 me-lg-4 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="CustomerNationalCode"
                    textboxType="nationalCode"
                    labelText="CustomerNationalCode"
                    defaultValue={
                      response?.CustomerNationalCode
                        ? response?.CustomerNationalCode
                        : customerInfo?.NationalId
                    }
                    resetForm={resetForm}
                    mode={mode }
                    required={requiredFields?.CustomerNationalCode}
                  />
                </div>

           <div className="col-lg-3 col-11">
                  <Person
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    value={
                      response?.RecipientPersonId
                        ? response?.RecipientPersonId
                        : customerInfo?.RecipientPersonId
                    }
                    resetForm={resetForm}
                    mode={mode}
                    WithSearch={false}
                    setPerson={setPerson}
                    returnObj={true}
                    name={"RecipientPersonDescription"}
                    label="RecipientPerson"
                    required={requiredFields?.RecipientPersonId}
                    valueString={response?.RecipientPersonDescription}

                  />
                </div>

                {!customer?.SundryCustomer ? (
                <div className="col-lg-5 col-11 d-flex" style={{ marginRight: "2px" }}>
                <div className="flex-grow-1">
                <Address
                  onChange={(e) => {
                    setShowAddressBox("selectMode");
                    return false;
                  }}
                  withMap={false}
                  hideDetail={true}
                  personContact={
                    changeAddress
                      ? convertAddress(changeAddress)
                      : response?.CustomerAddress
                      ? response?.CustomerAddress
                      : convertAddress(customerInfo?.Address)
                  }
                  mode={"view"}
                  required={requiredFields?.CustomerAddress}
                />
                </div>
           {mode!=='view' &&   <div className=" mt-4 text-end p-0">
                <Button
                  Icon={true}
                  value={
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAddressBox("createMode");
                      }}
                      className="checkButton d-flex align-items-center justify-content-center"
                    >
                      {" "}
                      <FontAwesomeIcon
                        icon={[ICON_TYPE, "plus"]}
                        size="2x"
                      />
                    </button>
                  }
                  btnType="primary"
                />
              </div>}
            
            {mode!=='view' &&  <div className=" mt-4 text-end p-0">
                <Button
                  Icon={true}
                  value={
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowAddressBox("selectMode");
                      }}
                      className="checkButton d-flex align-items-center justify-content-center "
                    >
                      {" "}
                      <FontAwesomeIcon
                        icon={[ICON_TYPE, "search"]}
                        size="2x"
                      />
                    </button>
                  }
                  btnType="primary"
                />
              </div>}
            </div>
                ) : (
                  <div className="col-lg-5 col-11 d-flex ">
                    <Textbox
                      Change={(e) => {
                        setUserChanges({ ...userChanges, ...e });
                      }}
                      textboxName="Address"
                      textboxType="text"
                      labelText="Address"
                      defaultValue={
                        response?.CustomerAddress
                          ? response?.CustomerAddress
                          : ""
                      }
                      resetForm={resetForm}
                      mode={mode }
                      required={requiredFields?.CustomerAddress}
                    />
                  </div>
                )}

          

                {/*                         <div className="col-lg-2">
                            <Textbox
                             Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                             textboxName="Prepayment"
                             textboxType="number"
                             labelText="Prepayment"
                             defaultValue={response?.Prepayment}
                             resetForm={resetForm}
                             mode={mode == 'view'?"view": mode}
                             required={true}
                            />
                        </div> */}
                {/*                         <div className="col-lg-2">
                            <Textbox
                            Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                            textboxName="VisitorPositionDescriptionEN"
                            textboxType="text"
                            labelText="VisitorPositionDescriptionEN"
                            defaultValue={response?.VisitorPositionDescriptionEN}
                            resetForm={resetForm}
                            mode={mode == 'view'?"view": mode}
                            />
                            </div> */}
                {/*  <div className="col-lg-2">
                                 <Textbox
                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                  textboxName="DistributorPositionDescriptionEN"
                                  textboxType="text"
                                  labelText="DistributorPositionDescriptionEN"
                                  defaultValue={response?.DistributorPositionDescriptionEN}
                                  resetForm={resetForm}
                                  mode={mode == 'view'?"view": mode}
                                 />
                                </div> */}
                {/*                         <div className="col-lg-2">
                            <Textbox
                             Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                             textboxName="SalesManagerPositionDescriptionEN"
                             textboxType="text"
                             labelText="SalesManagerPositionDescriptionEN"
                             defaultValue={response?.SalesManagerPositionDescriptionEN}
                             resetForm={resetForm}
                             mode={mode == 'view'?"view": mode}
                            />
                           </div> */}

                <div className="col-lg-2 col-11 mr-2">
                  <Position
                    name="VisitorPositionId"
                    label="VisitorPosition"
                    resetForm={resetForm}
                    value={
                      customerInfo?.VisitorPositionId
                        ? customerInfo?.VisitorPositionId
                        : response?.VisitorPositionId
                    }
                    mode={mode }
                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({ ...listPosition, VisitorPosition: e });
                    }}
                    required={requiredFields?.VisitorPositionId}
                  />
                </div>
                <div className="col-lg-2 col-11">
                  <Position
                    name="DistributorPositionId"
                    label="DistributorPosition"
                    resetForm={resetForm}
                    value={
                      customerInfo?.DistributorPositionId
                        ? customerInfo?.DistributorPositionId
                        : response?.DistributorPositionId
                    }
                    mode={mode }
                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({
                        ...listPosition,
                        DistributorPosition: e,
                      });
                    }}
                    required={requiredFields?.DistributorPositionId}
                  />
                </div>

                <div className="col-lg-2 col-11">
                  <Position
                    name="SalesManagerPositionId"
                    label="salesmanagerpositiondescription"
                    resetForm={resetForm}
                    value={
                      customerInfo?.SalesInvoiceStatusId
                        ? customerInfo?.SalesInvoiceStatusId
                        : response?.SalesManagerPositionId
                    }
                    mode={mode }
                    returnObj={true}
                    onChange={(e) => {
                      setListPosition({
                        ...listPosition,
                        SalesManagerPosition: e,
                      });
                    }}
                    required={requiredFields?.SalesManagerPositionId}
                  />
                </div>
                <div className="col-lg-3 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="DeliveryAddress"
                    textboxType="text"
                    labelText="DeliveryAddress"
                    defaultValue={
                      response?.DeliveryAddress
                        ? response?.DeliveryAddress:''
                    }
                    resetForm={resetForm}
                    mode={mode }
                    required={requiredFields?.DeliveryAddress}
                  />
                </div>

                <div className="col-lg-5 col-11">
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    textboxName="Description"
                    textboxType="textarea"
                    labelText="Description"
                    minHeight={1}
                    defaultValue={response?.Description}
                    resetForm={resetForm}
                    mode={mode }
                    maxLength={900}
                    letterCounter={true}
                    required={requiredFields?.Description}
                  />
                </div>
              </div>
            </div>
          </FormWithTitle>
          <div className="mt-3">
            <FormWithTitle title={trans("Details")}>
              <div>
                <div className="row align-items-center justify-content-between">
                  {mode !== "view" && (
                    <div className="col-2">
                      <div
                        onClick={handleOpenDetailForm}
                        className="col-2 mb-1 btn btn-success btn-sm d-flex align-items-center justify-content-between "
                        style={{
                          width: "70px",
                          maxHeight: "30px",
                          marginRight: "20px",
                          minWidth:'70px',
                        }}
                      >
                        <span className=" font-size-md ms-2 ">
                          {trans("add")}
                        </span>
                        <FontAwesomeIcon
                          size="xs"
                          icon={["fas", "plus"]}
                          className="color_text_light d-flex Requests__chatbox-reply-btn mx-1 p-1"
                          color="white"
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-10 row" style={{ justifyContent: "end" }}>
                    <div className="d-flex justify-content-end align-items-center">
                      {mode!="view"&&
                      <div className="d-flex align-items-center justify-content-center mb-1 flex-wrap">
                        <input
                          style={{ width: "30%" }}
                          onChange={(e) => {
                            setOptionalDiscount(
                              e.target.value.replaceAll(",", "")
                            );
                          }}
                          value={
                            optionalDiscount > 0
                              ? GroupingPriceFunction(+optionalDiscount)
                              : null
                          }
                          className="text-box__box form-control col-2 me-1 "
                          placeholder={trans("Discount")}
                          disabled={
                            salesInvoiceDetail.length == 0 ||
                            !priceList?.IsManual
                              ? true
                              : false
                          }
                        />
                        <div
                          onClick={(e) => {
                            if (
                              salesInvoiceDetail.length > 0 &&
                              priceList?.IsManual
                            ) {
                              e.preventDefault();
                              e.stopPropagation();
                              optionalDiscountHandlerAsync();
                            }
                          }}
                          className={`btn   ${
                            salesInvoiceDetail.length == 0 ||
                            !priceList?.IsManual
                              ? "btn-outline-secondary disabled"
                              : "btn-primary"
                          } btn-sm d-flex align-items-center justify-content-between  me-1 `}
                        >
                          <span className=" font-size-md ">
                            {trans("sharediscount")}
                          </span>
                          <FontAwesomeIcon
                            size="xs"
                            icon={[ICON_TYPE, "share"]}
                            className=" d-flex Requests__chatbox-reply-btn mx-1 p-1"
                            style={{
                              color:
                                salesInvoiceDetail.length == 0 ||
                                !priceList?.IsManual
                                  ? "gray"
                                  : "white",
                            }}
                          />
                        </div>
                      </div>
                      }
                      <div className={`${mode!="view"? "col-7" : "col-12"}  row justify-content-end mb-1`}>
                        <Headerbar
                          withPading={false}
                          headerContents={(docsClassification?.CalculateTax ||(docsClassification?.CalculateTax==null&& invoiceConstraint.HasTax && mode=='create') || mode!='create')?totalRows:{...totalRows,TotalTax:0}}
                          hasBorder={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {dataGridLoading ? (
                  <>
                    {(mode=="view" ? (salesInvoiceDetail?.length > 0 ): invoiceConstraint?.DetailDTO   )  ? (
                      <>
                        <DataGrid
                            useChangingNumberPlacement={true}
                         useLanguage={true}
                        responseList={responseList}
                          convertDateColNames={["ExpireDate"]}
                          DoubleClick={(e) => {
                            setSelectedObj(e);
                            setShowForm(true);
                            setDetailMode('view')
                          }}
                          decimalColumn={['SalesUnitPrice','Unit2Price','Unit1Price','SubTotalPrice']}
                          parentName={"SalesInvoiceDetailList"}
                          startIndex={26}
                          defaultValueOption={{ "-1": invoiceConstraint?.ItemNoPriceText?invoiceConstraint?.ItemNoPriceText:'' }}
                          theadData={mode!=='view'?Object.keys(invoiceConstraint?.DetailDTO):
                            Object.keys(salesInvoiceDetail?.[0])
                          }
                          tbodyData={
                            salesInvoiceDetail?.length > 0
                              ? salesInvoiceDetail
                              : [invoiceConstraint?.DetailDTO]
                          }
                          totalRecords={
                            salesInvoiceDetail?.length > 0 ? undefined : 0
                          }
                          scrollHeight={"67vh"}
                          minCellWidth={80}
                          selectedRowObjectCallback={selectedObjCallback}
                          handleEdit={
                            mode != "view"
                              ? (e) => {
                                  setSelectedObj(e);
                                  setDetailMode("edit");
                                  setShowForm(true);
                                }
                              : undefined
                          }
                          rowSelected={selectedObj}
                          handleDelete={
                            mode != "view"
                              ? (e) => {
                                  // Toast(
                                  //   trans("msg_deleteconfirm"),
                                  //   "warning",
                                  //   "alert",
                                  //   () => handleDeleteRow(e)
                                  // );
                                  Toast(
                                    trans("msg_deleteconfirm"),
                                  MessageType.confirmDelete,
                                    () => handleDeleteRow(e)
                                  );
                                }
                              : undefined
                          }
                          handleView={(e) => {
                            setSelectedObj(e);
                            setDetailMode("view");
                            setShowForm(true);
                          }}
                        />
                      </>
                    ) : (
                      <Message message={"NoDataForPreview"} type={"info"} />
                    )}
                  </>
                ) : (
                  <Loading />
                )}
              </div>
            </FormWithTitle>
          </div>

          <div className="card">
            <div className="card-body ">
              <div className="row">
                <div className="col-lg-2">
                  {/* <Textbox
                    useGroupingPrice={true}
                    textboxName="TotalPrice"
                    textboxType="text"
                    labelText="TotalPrice"
                    decimals={currencyInfo?.CurrencyRoundingPlace}
                    round={invoiceConstraint.FloorTaxDuty}
                    defaultValue={
                      payment.TotalPrice != 0
                        ? payment.TotalPrice + ""
                        : response?.TotalPrice
                        ? response?.TotalPrice + ""
                        : payment.TotalPrice
                    }
                    resetForm={resetForm}
                    mode={"view"}
                  /> */}
                  <PriceInput
                    name="TotalPrice"
                    label="TotalPrice"
                    decimals={currencyInfo?.CurrencyRoundingPlace}
                    round={invoiceConstraint.FloorTaxDuty}
                    defaultValue={
                      payment.TotalPrice != 0
                        ? payment.TotalPrice + ""
                        : response?.TotalPrice
                        ? response?.TotalPrice + ""
                        : payment.TotalPrice
                    }
                    resetForm={resetForm}
                    mode={"view"}
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    useGroupingPrice={true}
                    textboxName="Addition"
                    textboxType="text"
                    labelText="Addition"
                    defaultValue={
                      payment.Addition != 0
                        ? payment.Addition + ""
                        : response?.Addition
                        ? response?.Addition + ""
                        : payment.Addition
                    }
                    onChange={(e) => {
                      setPayment({
                        ...payment,
                        Addition: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  /> */}
                  <PriceInput
                    name="Addition"
                    label="Addition"
                    defaultValue={
                      payment.Addition != 0
                        ? payment.Addition + ""
                        : response?.Addition
                        ? response?.Addition + ""
                        : payment.Addition
                    }
                    onChange={(e) => {
                      setPayment({
                        ...payment,
                        Addition: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
             
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    useGroupingPrice={true}
                    textboxName="Deduction"
                    textboxType="text"
                    labelText="Deduction"
                    defaultValue={
                      payment.Deduction != 0
                        ? payment.Deduction + ""
                        : response?.Deduction
                        ? response?.Deduction + ""
                        : payment.Deduction
                    }
                    onChange={(e) => {
                      setPayment({
                        ...payment,
                        Deduction: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  /> */}
                  <PriceInput
                    name="Deduction"
                    label="Deduction"
                    defaultValue={
                      payment.Deduction != 0
                        ? payment.Deduction + ""
                        : response?.Deduction
                        ? response?.Deduction + ""
                        : payment.Deduction
                    }
                    onChange={(e) => {
                      setPayment({
                        ...payment,
                        Deduction: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    useGroupingPrice={true}
                    textboxName="GrandTotalPrice"
                    decimals={currencyInfo?.CurrencyRoundingPlace}
                    round={invoiceConstraint.FloorTaxDuty}
                    textboxType="text"
                    labelText="GrandTotalPrice"
                    defaultValue={
                      receive?.GrandTotalPrice != 0
                        ? receive?.GrandTotalPrice + ""
                        : response?.GrandTotalPrice
                        ? response?.GrandTotalPrice + ""
                        : receive?.GrandTotalPrice
                    }
                    resetForm={resetForm}
                    mode={"view"}
                  /> */}
                  <PriceInput
                    name="GrandTotalPrice"
                    decimals={currencyInfo?.CurrencyRoundingPlace}
                    round={invoiceConstraint.FloorTaxDuty}
                    label="GrandTotalPrice"
                    defaultValue={
                      receive?.GrandTotalPrice != 0
                        ? receive?.GrandTotalPrice + ""
                        : response?.GrandTotalPrice
                        ? response?.GrandTotalPrice + ""
                        : receive?.GrandTotalPrice
                    }
                    resetForm={resetForm}
                    mode={"view"}
                
                  />
                </div>
         
                <div className="col-lg-1">
                  <DictionarySelectBox
                    label="PaymentMethod"
                    name="PaymentMethodId"
                    baseUrl={INVENTORYANDSALES_URL}
                    endPoint={
                      ENDPOINTSINVENTORYANDSALES.Sales.BaseDefinitionAndSetting
                        .PaymentMethod.dictionary
                    }
                    resetForm={resetForm}
                    value={response?.PaymentMethodId}
                    mode={mode}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2">
                  {/* <Textbox
                    textboxName="Prepayment"
                    textboxType="text"
                    labelText="Prepayment"
                    defaultValue={
                      receive?.Prepayment != 0
                        ? receive?.Prepayment + ""
                        : response?.Prepayment
                        ? response?.Prepayment + ""
                        : receive?.Prepayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        Prepayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                    useGroupingPrice={true}
                  /> */}
                  <PriceInput
                    name="Prepayment"
                    label="Prepayment"
                    defaultValue={
                      receive?.Prepayment != 0
                        ? receive?.Prepayment + ""
                        : response?.Prepayment
                        ? response?.Prepayment + ""
                        : receive?.Prepayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        Prepayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    textboxName="DebitPayment"
                    textboxType="text"
                    labelText="DebitPayment"
                    defaultValue={
                      receive?.DebitPayment != 0
                        ? receive?.DebitPayment + ""
                        : response?.DebitPayment
                        ? response?.DebitPayment + ""
                        : receive?.DebitPayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        DebitPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                    useGroupingPrice={true}
                  /> */}
                  <PriceInput
                    name="DebitPayment"
                    label="DebitPayment"
                    defaultValue={
                      receive?.DebitPayment != 0
                        ? receive?.DebitPayment + ""
                        : response?.DebitPayment
                        ? response?.DebitPayment + ""
                        : receive?.DebitPayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        DebitPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    textboxName="NonDebitPayment"
                    textboxType="text"
                    labelText="NonDebitPayment"
                    defaultValue={
                      receive?.NonDebitPayment != 0
                        ? receive?.NonDebitPayment + ""
                        : response?.NonDebitPayment
                        ? response?.NonDebitPayment + ""
                        : receive?.NonDebitPayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        NonDebitPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                    useGroupingPrice={true}
                  /> */}
                  <PriceInput
                    name="NonDebitPayment"
                    label="NonDebitPayment"
                    defaultValue={
                      receive?.NonDebitPayment != 0
                        ? receive?.NonDebitPayment + ""
                        : response?.NonDebitPayment
                        ? response?.NonDebitPayment + ""
                        : receive?.NonDebitPayment
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        NonDebitPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={mode}
                  />
                </div>
                <div className="col-lg-2">
                  {/* <Textbox
                    textboxName="CreditPayment"
                    textboxType="text"
                    labelText="CreditPayment"
                    defaultValue={
                      receive?.GrandTotalPrice -
                      (+receive?.NonDebitPayment +
                        +receive?.DebitPayment +
                        +receive?.Prepayment) +
                      ""
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        CreditPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={"view"}
                    useGroupingPrice={true}
                  /> */}
                  <PriceInput
                    name="CreditPayment"
                    label="CreditPayment"
                    defaultValue={
                      receive?.GrandTotalPrice -
                      (+receive?.NonDebitPayment +
                        +receive?.DebitPayment +
                        +receive?.Prepayment) +
                      ""
                    }
                    onChange={(e) => {
                      setReceive({
                        ...receive,
                        CreditPayment: e.target.value.replaceAll(",", ""),
                      });
                    }}
                    resetForm={resetForm}
                    mode={"view"}
                  />
                </div>
                <div className="col-lg-4 d-flex justify-content-end">
                  
                  {mode != "view" && (
                    <div className="col-lg-12 mt-4  btns_form">
                      <Button outline={false} disabled={invoiceRef.current?.salesInvoiceNo?.value=='' || !salesInvoiceDetail.length} value="save" btnType="submit" />
                      {!jobId && (
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          cancel();
                        }}
                      />
                        )}
                    </div>
                  ) 
                  }
                </div>
              </div>
            </div>
          </div>
        </form>
      ) : (
        <Loading />
      )}
    </div>
  );
};
